import React from 'react';

type SettingsContext = {
    featureFlags: {
        launchLinkToCreatorCollectionsOnListing?: boolean;
        launchSearchTakeoverOnListings?: boolean;
        launchReportThisEventOnListings?: boolean;
    };
};
export const SettingsContext = React.createContext<Partial<SettingsContext>>(
    {},
);

type UserContext = {
    id: number;
};
export const UserContext = React.createContext<Partial<UserContext>>({});

type OrganizerContext = {
    id: string;
};
export const OrganizerContext = React.createContext<Partial<OrganizerContext>>(
    {},
);
